module.exports = __webpack_public_path__ + "static/media/Incorrect inclination of the tooth4.2a7f0dcc.png";